export function cleanupWakeWordOptions(data) {
    const cleanedData = JSON.parse(JSON.stringify(data));
    delete cleanedData.model_name;
    delete cleanedData.acoustic_name;
    delete cleanedData.acoustic;
    delete cleanedData.create_time;
    delete cleanedData.model_url;

    return cleanedData;
}